export default "__VITE_ASSET__CbU$1u4Q__"